<template>
    <div class="card mb-3">
        <div class="card-body">
            <div class="row">
                <div class="col-md-2" style="margin-top: 29px"><router-link :to="{name: 'themes.create'}" class="btn btn-secondary btn-block mb-3">افزودن طرح جدید</router-link></div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>فیلتر طرح ها</label>
                        <select class="form-control" v-model="status">
                            <option value="2">همه</option>
                            <option value="1">فعال</option>
                            <option value="0">غیرفعال</option>
                        </select>
                    </div>
                </div>
            </div>
            <hr>
            <Loading v-if="showLoading" />
            <div class="row" v-if="filteredThemes.length">
                <div  class="col-md-3 theme-parent p-2" v-for="theme in filteredThemes" :key="theme.themeId">
                <div class="table-bordered p-3" style="border-radius: 8px;">
                    <div class="row " >
                        <div class="col-12">
                            <img :src="`https://cardapi.sabinarya.com${theme.address}`" />
                        </div>
                        <div class="col-12" >
                            <hr>
                        </div>
                        <div class="col-12" >
                            <div  style=" display: flex; justify-content: space-between;" >
                                <h4 >{{ theme.title }}</h4>
                                <h6 > موجودی: {{ theme.stockCount }}</h6>
                            </div>
                        </div>
                        <div class="col-12">
                            <button style="width: 100%;" class="btn btn-primary" @click="$router.push(`/themes/update/${theme.themeId}`)"> مشاهده و ویرایش</button>
                        </div>
                
                        </div>
                    </div>
                </div>
            </div>
            <div class="alert alert-info mb-0" v-else>
                <p class="mb-0">داده ای یافت نشد</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Index',
    data(){
        return {
            showLoading: true,
            status: 2,
            themes: [],
            filteredThemes: []
        }
    },
    watch: {
        status(value){
            this.filteredThemes = value == 1 ? this.themes.filter(theme => theme.status) : (value == 0 ? this.themes.filter(theme => !theme.status) : this.themes)
        }
    },
    methods: {
        getData(){
            this.$api.get('Cards/Themes').then(({data}) => {
                if(data.status){
                    this.themes = data.result;
                    this.filteredThemes = data.result;
                }
            }).finally(() => {
                this.showLoading = false;
            })
        }
    },
    created(){
        this.getData();
    }
}
</script>